<template>
  <div class="d-flex flex-column justify-center pb-12" style="height: calc(100vh - 56px)">
    <v-icon size="128" color="warning">mdi-alert</v-icon>
    <span class="text-h4 text-center font-weight-bold">404 NotFound</span>
    <span class="text-subtitle-1 text-center">Please confirm that the URL is correct</span>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="scss" scoped>
.v-icon::after {
  width: 0 !important;
}
</style>
